import React from "react";
import styled from "styled-components";

import icon from "images/track_guides/icon";
import texture from "images/v3/overlay_texture-teal1.png";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	background-color: #012126;
	background-image: url(${texture});
	background-size: contain;
	padding: 15px;
	margin-bottom: 30px;
	box-shadow: 0 0 5px 5px rgba(89, 155, 164, 0.5);
`;

const Icon = styled.img`
	width: 120px;
	height: auto;
	margin-right: 15px;

	@media (max-width: 576px) {
		width: 60px;
	}
`;

/* const Title = styled.h1`
	margin: 0;
	margin-bottom: 15px;
	color: #599ba4;
	text-transform: uppercase;
	line-height: 1;
`;

const Text = styled.p`
	margin: 0;
	color: white;
	font-family: "Cera Basic", "Open Sans", "Sans Serif";
	font-size: 1.2em;
	line-height: 1.5;
`; */

const Headline = ({ title, text }) => (
	<Wrapper>
		<Icon src={icon} />
		<div>
			<h1 className="TGh1">{title}</h1>
			<p className="TGp">{text}</p>
		</div>
	</Wrapper>
);

export default Headline;
